import(/* webpackMode: "eager" */ "/builds/b4CDwResf/1/messika/messika-digitale/messika/messika-nextjs/app/global-error.jsx");
